<template>
  <master-page style="background: var(--v-principalBackground-base)">

    <v-row class="px-2 mt-6" style="display: flex; justify-content: center; align-items: center">
      <v-card flat style="background: var(--v-chartCardBackground-base)" :style="$vuetify.breakpoint.smAndDown ? 'width: 100vw': 'width: 35vw'">
        <div v-if="mostrarFinancas" class="pa-4" style="display: flex" :style="$vuetify.breakpoint.smAndDown ? 'justify-content: space-around' : 'justify-content: center'">
          <span style="margin-right: 10px; font-weight: bold; font-size: 18px">Recursos Disponíveis:</span> <span class="mr-2" style="font-size: 18px">{{totalDisponivel.toMoeda(true)}}</span>
          <v-icon @click="InformacaoTela('<div> Posição dos saldos bancários </div> <div>(todos os bancos ativos) na data corrente.</div>')" color="secondary">mdi-information</v-icon>
        </div>
        <div v-else class="pa-4" style="display: flex" :style="$vuetify.breakpoint.smAndDown ? 'justify-content: space-around' : 'justify-content: center'">
          <span style="margin-right: 10px; font-size: 18px; color: gray">Indisponível</span>
        </div>
      </v-card>
    </v-row>
    
    <div class="mt-6">
      <v-row style="background-color:var(--v-chartCardBackground-base); border-radius: 10px; display: flex; justify-content: space-around; align-items: center" :style="$vuetify.breakpoint.smAndDown ? 'margin-left: 0px; margin-right: 0px' : $vuetify.breakpoint.mdAndDown ? 'margin-left: 30px; margin-right: 30px' : 'margin-left: 90px; margin-right: 90px'">
        <div class="mt-4" style="width: 100%; display: flex; align-items: center; justify-content: center">
          <span style="font-size: 26px; font-weight: bold" class="mr-2">{{fluxobancario.ano}}</span>
          <v-icon @click="InformacaoTela('<div>Total de receitas e despesas de acordo com o plano de contas financeiro dentro ano corrente.</div>')" color="secondary">mdi-information</v-icon>
        </div>
        <v-col cols="12" sm="12" md="5" lg="5">
          <v-card flat class="mx-4" v-if="mostrarFinancas">
            <v-card-title>
              <span style="font-size: 26px">Receitas</span>
            </v-card-title>
            <v-card-subtitle>
              <span style="font-size: 20px">{{fluxobancario.receitaTotal.toMoeda(true)}}</span>
            </v-card-subtitle>
            <v-card-text style="display: flex; align-items: center; justify-content: center; margin-top: 8%">
              <pie-chart v-if="fluxobancario.receita.id.length > 0" id="PieChart" :headers="fluxobancario.receita.nome" :data="fluxobancario.receita.valor"/>
            </v-card-text>
          </v-card>
          <v-card flat class="mx-4 mb-4" v-else style="display: flex; justify-content: center; align-items: center">
            <span style="margin-right: 10px; font-size: 18px; color: gray">Indisponível</span>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="7">
          <v-card flat class="mx-4" v-if="mostrarFinancas">
            <v-card-title>
              <span style="font-size: 26px">Despesas</span>
            </v-card-title>
            <v-card-subtitle>
              <span style="font-size: 20px">{{fluxobancario.despesaTotal.toMoeda(true)}}</span>
            </v-card-subtitle>
            <v-card-text style="display: flex; align-items: center; justify-content: center">
              <bar-chart v-if="fluxobancario.despesa.id.length > 0" id="BarChart" title="Despesas" :headers="fluxobancario.despesa.nome" :data="fluxobancario.despesa.valor"/>
            </v-card-text>
          </v-card>
          <v-card flat class="mx-4 mb-4" v-else style="display: flex; justify-content: center; align-items: center">
            <span style="margin-right: 10px; font-size: 18px; color: gray">Indisponível</span>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div class="mt-6" style="margin-bottom: 50px">
      <v-row style="background-color: var(--v-chartCardBackground-base); border-radius: 10px; display: flex; justify-content: space-around; align-items: flex-start" :style="$vuetify.breakpoint.smAndDown ? 'margin-left: 0px; margin-right: 0px' : $vuetify.breakpoint.mdAndDown ? 'margin-left: 30px; margin-right: 30px' : 'margin-left: 90px; margin-right: 90px'">
        <v-col cols="12" sm="12" md="7" lg="6" class="pa-0">
          <v-card flat>
            <v-card-title>
              <span class="mr-2" style="font-size: 26px">Projetos Ativos</span>
              <v-icon @click="InformacaoTela('Receitas e Despesas relacionadas aos projetos ativos e seus respectivos saldos.')" color="secondary">mdi-information</v-icon>
            </v-card-title>
            <v-card-text v-if="mostrarFinancas">
              <v-data-table :headers="headers" :items="listaProjeto" :options.sync="listaOpt" :server-items-length="totalLista" dense>
                <template v-slot:[`item.nome`]="{ item }">
                  <span style="font-size: 12px">{{item.nome}}</span>                  
                </template>
                <template v-slot:[`item.receita`]="{ item }">
                  <div style="width: 100%" class="text-end">
                    <span style="font-size: 12px"> {{item.receita? item.receita.toMoeda() : new Number(0).toMoeda()}} </span>
                  </div>
                </template>
                <template v-slot:[`item.despesa`]="{ item }">
                  <div style="width: 100%" class="text-end">
                    <span style="font-size: 12px"> {{item.despesa? item.despesa.toMoeda() : new Number(0).toMoeda()}} </span>
                  </div>
                </template>
                <template v-slot:[`item.diferenca`]="{ item }">
                  <div style="width: 100%" class="text-end">
                    <span style="font-size: 12px" :style="item.diferenca < 0 ? 'color: red' : ''"> {{item.diferenca? item.diferenca.toMoeda() : new Number(0).toMoeda()}} </span>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-text v-else>
              <span style="margin-right: 10px; font-size: 18px; color: gray">Indisponível</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="4" class="pa-0">
          <v-card flat class="mx-4">
            <v-card-title>
              <span style="font-size: 26px; max-width: 350px; word-break: break-word !important">Beneficiários por Faixa Etária</span>
            </v-card-title>
            <v-card-subtitle>
              <span style="font-size: 20px">Beneficiários em projetos ativos.</span> <br/>
              <span style="font-size: 20px">Total: </span><span style="font-size: 20px; font-weight: bold">{{beneficiarios.total}}</span>
              <v-icon style="margin-left: 10px; margin-top: -5px" @click="InformacaoTela('Beneficiários em projetos ativos por faixa etária, sendo que, <br/> o beneficiário que estiver em mais de um projeto <br/> contará apenas uma vez.')" color="secondary">mdi-information</v-icon>
            </v-card-subtitle>
            <v-card-text style="display: flex; align-items: center; justify-content: center">
              <div style="width: 85%">
                <doughnut-chart v-if="beneficiarios" id="DoughnutChart" :headers="beneficiarios.legenda" :data="beneficiarios.quantidade"/>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>   

    <div class="mt-6" style="margin-bottom: 50px">
      <v-row class="pb-4" style="background-color: var(--v-chartCardBackground-base); border-radius: 10px; display: flex; justify-content: space-around; align-items: flex-start" :style="$vuetify.breakpoint.smAndDown ? 'margin-left: 0px; margin-right: 0px' : $vuetify.breakpoint.mdAndDown ? 'margin-left: 30px; margin-right: 30px' : 'margin-left: 90px; margin-right: 90px'">
        <v-col cols="12" class="pa-0 py-2" style="display: flex; align-items: center; justify-content: center">
          <span style="font-weight: bold; font-size: 22px">Beneficiários (Projetos Ativos)</span>
          <v-icon style="margin-left: 10px; margin-top: -5px" @click="InformacaoTela('Informações relativas à meta, retenção e evasão dos beneficiários em projetos ativos. <br/><br/> Percentual de Retenção: Total de retidos / Meta. <br/> Percentual de Evasão: Total de evasores / Total de Beneficiários.')" color="secondary">mdi-information</v-icon>
        </v-col>
        <v-col cols="12">
          <v-autocomplete v-model="projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="onSearchProjeto" item-text="codigoNome" item-value="id" label="Projeto" dense outlined clearable/>
        </v-col>
        <v-col cols="12" style="display: flex; flex-direction: column; align-items: center; justify-content: center">
          <v-simple-table dense style="width: 100%">
            <thead>
              <tr>
                <th class="text-center" :style="$vuetify.breakpoint.mdAndDown ? 'font-size: 110%' : 'font-size: 140%'">Meta</th>
                <th class="text-center" :style="$vuetify.breakpoint.mdAndDown ? 'font-size: 110%' : 'font-size: 140%'">Retenção</th>
                <th class="text-center" :style="$vuetify.breakpoint.mdAndDown ? 'font-size: 110%' : 'font-size: 140%'">Evasão</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center" :style="$vuetify.breakpoint.mdAndDown ? 'font-size: 110%' : 'font-size: 140%'">{{visaoBeneficiario.totalMetaBeneficiarios}}</td>
                <td class="text-center" :style="$vuetify.breakpoint.mdAndDown ? 'font-size: 110%' : 'font-size: 140%'">{{visaoBeneficiario.totalInativoBeneficiarios}}</td>
                <td class="text-center" :style="$vuetify.breakpoint.mdAndDown ? 'font-size: 110%' : 'font-size: 140%'">{{visaoBeneficiario.totalAtivoBeneficiarios}}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="12" class="py-4">
          <v-divider style="border-top: 1px dashed gray;"/>
        </v-col>
        <v-col class="mt-4" cols="12">
          <v-row class="pa-0" dense>
            <v-col cols="12" sm="4" style="display: flex; align-items: center; justify-content: center; width: 100%">
              <div style="display: flex; flex-direction: column; line-height: 50px">
                <span>% Retenção: <span>{{visaoBeneficiario.percentualEvasao.toMoeda()}}</span></span>
                <span>% Evasão: <span>{{visaoBeneficiario.percentualRetencao.toMoeda()}}</span></span>
              </div>
            </v-col>
            <v-col cols="12" sm="8" style="display: flex; align-items: center; justify-content: center; width: 100%">
              <bar-chart2 id="Stackbar" :title="''" :headers="testeHeader" :data="testeValor"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div class="mt-6" style="margin-bottom: 50px">
      <v-row class="pb-4" style="background-color: var(--v-chartCardBackground-base); border-radius: 10px; display: flex; justify-content: space-around; align-items: flex-start" :style="$vuetify.breakpoint.smAndDown ? 'margin-left: 0px; margin-right: 0px' : $vuetify.breakpoint.mdAndDown ? 'margin-left: 30px; margin-right: 30px' : 'margin-left: 90px; margin-right: 90px'">
        <v-col cols="12" class="pa-0 py-2" style="display: flex; align-items: center; justify-content: center">
          <span style="font-weight: bold; font-size: 22px">Aniversariantes</span>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="4" style="display: flex; flex-direction: column; align-items: center; justify-content: center">
          <span style="font-weight: bold; font-size: 18px">Recurso Pessoal</span>
          <v-data-table style="width: 100%" :headers="headerAniversario" :items="aniversariantes.pessoal" :items-per-page="-1" hide-default-footer dense/>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="4" style="display: flex; flex-direction: column; align-items: center; justify-content: center">
          <span style="font-weight: bold; font-size: 18px">Doador</span>
          <v-data-table style="width: 100%" :headers="headerAniversario" :items="aniversariantes.doador" :items-per-page="-1" hide-default-footer dense/>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="4" style="display: flex; flex-direction: column; align-items: center; justify-content: center">
          <span style="font-weight: bold; font-size: 18px">Beneficiário</span>
          <v-data-table style="width: 100%" :headers="headerAniversario" :items="aniversariantes.beneficiario" :items-per-page="-1" hide-default-footer dense/>
        </v-col>
      </v-row>
    </div>

  </master-page>
</template>

<script>
import FluxoBancarioService from '../../core/services/financeiro/FluxoBancarioService';
import { BeneficiarioService, PessoalService, ProjetoService } from '../../core/services/projetos';
import Swal from 'sweetalert2'
import DoadorService from '../../core/services/doacao/DoadorService';
import UsuarioService from '../../core/services/geral/UsuarioService';

export default {
  data: () => ({
    sessionApp: {},
    permissoes: [],
    mostrarFinancas: false,
    beneficiarios: {
      legenda: [],
      percentagem: [],
      quantidade: [],
      total: 0
    },
    fluxobancario: {
      receita: {
        id: [],
        nome: [],
        valor: []
      },
      despesa: {
        id: [],
        nome: [],
        valor: []
      },
      ano: 0,
      despesaTotal: 0,
      receitaTotal: 0
    },
    aniversariantes: {
      pessoal: [],
      doador: [],
      beneficiario: []
    },
    listaProjeto: [],
    totalLista: 0,
    headers: [
      { text: 'Nome', value: 'nome', class: 'text-center', sortable: false },
      { text: 'Receitas', value: 'receita', sortable: false },
      { text: 'Despesas', value: 'despesa', sortable: false },
      { text: 'Saldo', value: 'diferenca', sortable: false }
    ],
    headerAniversario: [
      { text: 'Nome', value: 'nome', class: 'text-center', sortable: false }
    ],
    totalDisponivel: 0,
    listaOpt: {
      itemsPerPage: 15
    },
    projetoId: null,
    isProjetoLoading: false,
    onSearchProjeto: null,
    projetos: [],
    visaoBeneficiario: {},
    testeHeader: [
      "Evasão (%)",
      "Retenção (%)"
    ],
    testeValor: []
  }),
  mounted() {
    this.sessionApp = JSON.parse(localStorage.getItem("sessionApp"));
    new UsuarioService().ObterPorId(this.sessionApp.usuarioId, "Permissoes").then(
      res => {
        this.permissoes = res.data.permissoes;
        this.mostrarFinancas =  this.PermissaoFinanceiroHome();
      }
    )
    
    this.GetBeneficiarios();
    this.GetReceitaDespesa();
    this.GetTotalDisponivel();
    this.CarregarAniversariantes();
    this.CarregaVisaoBeneficiario();
  },
  watch: {
    listaOpt: function(){
      this.GetListagemProjeto(this.listaOpt.itemsPerPage, this.listaOpt.page);
    },
    projetoId: function(){
      this.CarregaVisaoBeneficiario()
    },
    onSearchProjeto(val){
      if(this.isProjetoLoading) return;
      if(this.projetoId) return;
      if(!val) return;

      this.isProjetoLoading = true;
      new ProjetoService().AutoComplete(val)
      .then(
        res=>{
          this.projetos = res.data
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      )
      .finally(() => (this.isProjetoLoading = false))
    },
  },
  methods: {
    GetBeneficiarios(){
      new ProjetoService().Beneficiarios().then(
        res => {
          this.beneficiarios = res.data;
          this.beneficiarios.total = this.beneficiarios.quantidade.reduce(function(soma, i) {
            return soma + i;
          })
        }
      )
    },
    GetReceitaDespesa(){
      new FluxoBancarioService().Grafico().then(
        res => {
          this.fluxobancario = res.data;
        }
      )
    },
    GetListagemProjeto(pageSize, page){
      new ProjetoService().ListaHome(pageSize, page).then(
        res => {
          this.listaProjeto = res.data.projetos;
          this.totalLista = res.data.total;
        }
      )
    },
    GetTotalDisponivel(){
      new FluxoBancarioService().TotalDisponivel().then(
        res => {
          this.totalDisponivel = res.data.total;
        }
      )
    },
    CarregarAniversariantes(){
      new BeneficiarioService().Aniversariantes().then(
        res => {
          this.aniversariantes.beneficiario = res.data;
        }
      )
      new PessoalService().Aniversariantes().then(
        res => {
          this.aniversariantes.pessoal = res.data;
        }
      )
      new DoadorService().Aniversariantes().then(
        res => {
          this.aniversariantes.doador = res.data;
        }
      )
    },
    CarregaVisaoBeneficiario(){
      new ProjetoService().VisaoBeneficiarios(this.projetoId).then(
        res => {
          this.visaoBeneficiario = res.data
          this.testeValor = [];
          this.testeValor.push(this.visaoBeneficiario.percentualRetencao);
          this.testeValor.push(this.visaoBeneficiario.percentualEvasao);
        }        
      )
    },
    PermissaoFinanceiroHome(){
      var necessario = ['CadFornecedor', 'CadCompromissos', 'QuitacaoCompromisso', 'LancamentoBancario1', 'CadRecebiveis', 'BaixaRecebiveis', 'GeracaoRecebiveis', 'EnvioBoletos', 'LancamentoBancario2', 'RetornoBancario'];
      var teste = 0;
      this.permissoes.forEach(x => {
        if(necessario.find(y => y == x.menu)){
          teste ++;
        }
      })
      return teste == 10 ? true : false;
    },
    InformacaoTela(info){
      Swal.fire({
        html: info
      })
    }
  }
}
</script>

<style scoped>
  .listaCard {
    color: white !important;
  }
</style>